module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Rheinwald_COA-610899c36c3247cfcdd87518ec479d73.svg";